import { List } from 'antd';
import Paragraph from 'components/atoms/Paragraph';
import TranslateText from 'components/hoc/TranslateText';
import React from 'react';

interface ISimpleListComponent {
    data: string[];
}

const SimpleListComponent: React.FC<ISimpleListComponent> = props => {
    const { data } = props;

    return (
        <List
            className="simple-list-component"
            bordered={false}
            dataSource={data}
            renderItem={item => (
                <List.Item>
                    <Paragraph text="-" mark={true} /> <TranslateText>{item}</TranslateText>
                </List.Item>
            )}
        />
    );
};

export default SimpleListComponent;
